import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Login from './screens/Login'
import RequireAuth from './components/RequireAuth'
import Projects from './screens/Projects'
import Applications from './screens/Applications'
import NewApplication from './screens/NewApplication'
import Implementation from './screens/Implementation'
import Dashboard from './screens/Dashboard'
import Estimate from './screens/Estimate'
import NewAppImplementation from './screens/NewAppImplementation'
import Stockrooms from './screens/Stockrooms'
import Acts from './screens/Acts'
import Employees from './screens/Employees'

const App = () => (
  <div>
    <Routes>
      <Route
        path="/"
        element={
          <RequireAuth>
            <Applications />
          </RequireAuth>
        }
      />
      <Route
        path="/applications"
        element={
          <RequireAuth>
            <Applications />
          </RequireAuth>
        }
      />
      <Route
        path="/application/new"
        element={
          <RequireAuth>
            <NewApplication />
          </RequireAuth>
        }
      />
      <Route
        path="/application-implementation/new"
        element={
          <RequireAuth>
            <NewAppImplementation />
          </RequireAuth>
        }
      />
      <Route
        path="/projects"
        element={
          <RequireAuth>
            <Projects />
          </RequireAuth>
        }
      />
      <Route
        path="/estimate"
        element={
          <RequireAuth>
            <Estimate />
          </RequireAuth>
        }
      />
      <Route
        path="/implementation"
        element={
          <RequireAuth>
            <Implementation />
          </RequireAuth>
        }
      />
      <Route
        path="/analytics"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/stockroom"
        element={
          <RequireAuth>
            <Stockrooms />
          </RequireAuth>
        }
      />
      <Route
        path="/acts"
        element={
          <RequireAuth>
            <Acts />
          </RequireAuth>
        }
      />
      <Route
        path="/employees"
        element={
          <RequireAuth>
            <Employees />
          </RequireAuth>
        }
      />
      <Route path="/login" element={<Login />} />
    </Routes>
  </div>
)

export default App
